var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Lista zamówień")]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pr-2", attrs: { md: "3", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { placeholder: "Szukaj" },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "px-2", attrs: { md: "3", cols: "12" } },
            [
              _c("v-combobox", {
                attrs: {
                  items: _vm.itemsFilterType,
                  label: "Usługi",
                  multiple: "",
                  placeholder: "Wszystkie",
                  "small-chips": ""
                },
                model: {
                  value: _vm.filterType,
                  callback: function($$v) {
                    _vm.filterType = $$v
                  },
                  expression: "filterType"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-col",
            { staticClass: "pl-2", attrs: { md: "6", cols: "12" } },
            [
              _c("v-combobox", {
                attrs: {
                  items: _vm.itemsFilterStatus,
                  label: "Status",
                  multiple: "",
                  placeholder: "Wszystkie",
                  "small-chips": ""
                },
                model: {
                  value: _vm.filterStatus,
                  callback: function($$v) {
                    _vm.filterStatus = $$v
                  },
                  expression: "filterStatus"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "table-less-padding",
        attrs: {
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          "custom-filter": _vm.filterOverAllProperty,
          headers: _vm.headers,
          items: _vm.orders,
          search: _vm.search,
          dense: "",
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending,
          "items-per-page": 5
        },
        on: {
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.company_name))]),
                  _c("td", [_vm._v(_vm._s(item.created_by_name))]),
                  _c("td", [_vm._v(_vm._s(item.created_at))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-row",
                        [
                          item.items.filter(function(v) {
                            return v.type === "hotel"
                          }).length > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { lg: "6", md: "12" }
                                },
                                [
                                  _c("h4", [_vm._v("Hotele")]),
                                  _vm._l(
                                    item.items.filter(function(v) {
                                      return v.type === "hotel"
                                    }),
                                    function(hotel) {
                                      return _c("single-service-order-chip", {
                                        key: hotel.id,
                                        attrs: {
                                          status: hotel.status,
                                          text: "Usługa zakwaterowania"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          item.items.filter(function(v) {
                            return v.type === "flight"
                          }).length > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { lg: "6", md: "12" }
                                },
                                [
                                  _c("h4", [_vm._v("Loty")]),
                                  _vm._l(
                                    item.items.filter(function(v) {
                                      return v.type === "flight"
                                    }),
                                    function(flight) {
                                      return _c("single-service-order-chip", {
                                        key: flight.id,
                                        attrs: {
                                          status: flight.status,
                                          text: "Przelot"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          item.items.filter(function(v) {
                            return v.type === "rail"
                          }).length > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { lg: "6", md: "12" }
                                },
                                [
                                  _c("h4", [_vm._v("Koleje")]),
                                  _vm._l(
                                    item.items.filter(function(v) {
                                      return v.type === "rail"
                                    }),
                                    function(rail) {
                                      return _c("single-service-order-chip", {
                                        key: rail.id,
                                        attrs: {
                                          status: rail.status,
                                          text: "Koleje"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          item.items.filter(function(v) {
                            return v.type === "car"
                          }).length > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { lg: "6", md: "12" }
                                },
                                [
                                  _c("h4", [_vm._v("Wynajem pojazdów")]),
                                  _vm._l(
                                    item.items.filter(function(v) {
                                      return v.type === "car"
                                    }),
                                    function(car) {
                                      return _c("single-service-order-chip", {
                                        key: car.id,
                                        attrs: {
                                          status: car.status,
                                          text: "Wynajem pojazdu"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          item.items.filter(function(v) {
                            return v.type === "insurance"
                          }).length > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { lg: "6", md: "12" }
                                },
                                [
                                  _c("h4", [_vm._v("Ubezpieczenia")]),
                                  _vm._l(
                                    item.items.filter(function(v) {
                                      return v.type === "insurance"
                                    }),
                                    function(insurance) {
                                      return _c("single-service-order-chip", {
                                        key: insurance.id,
                                        attrs: {
                                          status: insurance.status,
                                          text: "Ubezpieczenie"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          item.items.filter(function(v) {
                            return v.type === "other"
                          }).length > 0
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { lg: "6", md: "12" }
                                },
                                [
                                  _c("h4", [_vm._v("Inne usługi")]),
                                  _vm._l(
                                    item.items.filter(function(v) {
                                      return v.type === "other"
                                    }),
                                    function(other) {
                                      return _c("single-service-order-chip", {
                                        key: other.id,
                                        attrs: {
                                          status: other.status,
                                          text: "Inna usługa"
                                        }
                                      })
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("td", [
                    _c(
                      "span",
                      {
                        staticClass: "mx-1",
                        staticStyle: { "text-align": "center" }
                      },
                      [_c("order-chip", { attrs: { status: item.status } })],
                      1
                    )
                  ]),
                  _c("td", {
                    domProps: { textContent: _vm._s(item.order_group_id) }
                  }),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            to:
                                              "/admin/travel-service/edit/" +
                                              item.id,
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" Przejdź do szczegółów zamówienia ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }